import React from 'react'
import { useSelector } from 'react-redux'
import userActions from '../actions'
import ReuseConfirmationDialog from 'components/common/ReuseConfirmationDialog'

const ConfirmationDialog = () => {
    const { editUser, isConfirmationDialogOpen } = useSelector(
        (state) => state.user,
    )
    const { setDeleteConfirmationVisibility, deleteUser } = userActions()

    const handleClose = () => {
        setDeleteConfirmationVisibility(false)
    }

    return (
        <ReuseConfirmationDialog
            open={isConfirmationDialogOpen}
            handleConfirm={() => {
                deleteUser(editUser.id)
                setDeleteConfirmationVisibility(false)
            }}
            handleCancel={handleClose}
            dialogData={{
                title: 'Remove Confirmation',
                desc: 'Are you sure you want to permanently remove the member?',
            }}
        />
    )
}

export default ConfirmationDialog
